import type {
  LayoutRouteProps,
  PathRouteProps,
  RouteObject,
  RouteProps,
} from 'react-router'
import { lazy, type ReactNode } from 'react'

export const ROUTE_PATHS = {
  default: '/',
  analysis: '/analysis',
  corridors: '/corridors',
  routing: '/routing',
  chat: '/chat',
  userManual: '/user-manual',
  login: 'login',
  auth: '/auth',
  notFound: '/404',
}

export default [
  route(ROUTE_PATHS.login, () => import('./pages/(auth)/login/page')),
  layout(
    () => import('./pages/(auth)/protected-route'),
    [
      layout(
        () => import('./modules/url-parameters/layout'),
        [
          route(ROUTE_PATHS.default, () => import('./pages/main/page'), []),
          route(
            ROUTE_PATHS.analysis,
            () => import('./pages/analysis/page'),
            [],
          ),
          route(
            ROUTE_PATHS.corridors,
            () => import('./pages/corridors/page'),
            [],
          ),
          route(ROUTE_PATHS.routing, () => import('./pages/routing/page'), []),
        ],
      ),
      route(ROUTE_PATHS.chat, () => import('./pages/chat/page'), []),
      route(
        ROUTE_PATHS.userManual,
        () => import('./pages/user-manual/page'),
        [],
      ),
    ],
  ),
  // Need to be last
  route(ROUTE_PATHS.notFound, () => import('./pages/not-found/page')),
  route('*', () => import('./pages/not-found/page')),
] as RouteObject[]

function route(
  path: string,
  file: Parameters<typeof lazy>[0],
  children?: RouteProps[],
  props?: PathRouteProps,
): PathRouteProps {
  return {
    path,
    ...layout(file, children, props),
  }
}

function layout(
  file: Parameters<typeof lazy>[0],
  children?: RouteProps[],
  props?: LayoutRouteProps,
): LayoutRouteProps {
  return {
    Component: lazy(file),
    children: children as ReactNode,
    ...props,
  }
}
